module.exports = __webpack_public_path__ + "static/media/escudo.e92a1100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/escudo.jpg
// module id = 1293
// module chunks = 0